import LayoutResultados from '../../containers/LayoutResultados';
import Resultados from '../../pages/Resultados';
import Estadisticas from '../../pages/Estadisticas';
import React from 'react';
import { themes } from '../../styles/themes';
import { ThemeProvider } from 'styled-components/macro';
import { usePage } from '../../contexts/pageContext';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Spinner from '../../components/Spinner';
import ScrollToTop from '../../components/ScrollToTop';
import Print from '../../print/Print';
import useIni from '../../hooks/useIni';

/**
 * Switch que renderiza la página correspondiente al estado de la aplicación
 */

const PageSwitch = ({ ...rest }) => {
  const pageState = usePage();
  const ini = useIni();
  const nomenclator = useNomenclator();
  const page = pageState && pageState.urlInfo && pageState.urlInfo.page;
  const getPage = React.useMemo(() => {
    switch (page) {
      case 'presidente': {
        return <Resultados nomenclator={nomenclator} />;
      }
      case 'estadisticas': {
        return <Estadisticas nomenclator={nomenclator} />;
      }
      default:
        break;
    }
  }, [page, nomenclator]);

  if (!pageState || !pageState.data) return null;
  if (pageState.isError) throw new Error();
  const { id } = pageState.urlInfo;
  return (
    <>
      <Print
        id={id}
        data={pageState.data}
        nomenclator={nomenclator}
        page={page}
        ini={ini}
      />
      <div
        css={`
          @media print {
            display: none !important;
          }
        `}
      >
        <ThemeProvider theme={themes[page]}>
          {page !== 'estadisticas' ? (
            <LayoutResultados nomenclator={nomenclator}>
              <div id="top" />
              <Spinner loading={pageState.isLoading} />
              {getPage}
              <ScrollToTop />
            </LayoutResultados>
          ) : (
            <>
              <div id="top" />
              <Spinner loading={pageState.isLoading} />
              {getPage}
              <ScrollToTop />
            </>
          )}
        </ThemeProvider>
      </div>
    </>
  );
};

export default PageSwitch;
